jQuery($ => {
    class Checkboxes {
      constructor(element) {
        this._              = element;
        this._element       = $(element);
        this._group         = this._element.find('.m-checkboxes__group');
        this._checkbox      = this._group.find('.m-checkboxes__checkbox');
        this._checkboxInput = this._checkbox.find('.a-checkbox__input');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._checkboxInput.on('keydown', this.handleCheckboxKeydown);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Checkbox Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleCheckboxKeydown = event => {
        switch (event.key) {
          case "ArrowUp":
            event.preventDefault();
            const $prevCheckbox = $(event.target).closest('.m-checkboxes__checkbox').prev();

            if ($prevCheckbox[0]) {
              $prevCheckbox.find(".a-checkbox__input").focus();
            }
            break;

          case "ArrowDown":
            event.preventDefault();
            const $nextCheckbox = $(event.target).closest('.m-checkboxes__checkbox').next();

            if ($nextCheckbox[0]) {
              $nextCheckbox.find(".a-checkbox__input").focus();
            }
            break;

          case "Home":
            event.preventDefault();
            this._checkbox
              .parent()
              .find(".m-checkboxes__checkbox")
              .first()
              .find(".a-checkbox__input")
              .focus();
            break;

          case "End":
            event.preventDefault();
            this._checkbox
              .parent()
              .find(".m-checkboxes__checkbox")
              .last()
              .find(".a-checkbox__input")
              .focus();
            break;
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.checkboxes = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].checkboxes = new Checkboxes(_[i], opt);
        else
          ret = _[i].checkboxes[opt].apply(_[i].checkboxes, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-checkboxes').checkboxes();
});